/**
 * The one Firebase app instance.
 *
 * The apiKey below is not a secret. Firebase web config identifies the
 * project to Google's endpoints; it grants nothing on its own. What actually
 * protects data is Firestore rules and the role checks every callable runs
 * server-side. Treating this value as a credential — hiding it in an env file
 * that ships in the bundle anyway — buys nothing and implies a protection
 * that is not there.
 */

import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCJF-Fw4O1q5AB2ecG6uwpidfBNIp7S5Dw',
  authDomain: 'somexai-pandp.firebaseapp.com',
  projectId: 'somexai-pandp',
  storageBucket: 'somexai-pandp.firebasestorage.app',
  messagingSenderId: '76403086637',
  appId: '1:76403086637:web:125a2b44996331550d6fa4',
  measurementId: 'G-QXJ3QW4GHR',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/** Callables live in us-central1, where they are deployed. */
export const functions = getFunctions(app, 'us-central1');

/**
 * The browser tests (web/e2e) run the app against the Firebase emulators.
 * `VITE_USE_EMULATORS=1` is read at build time, so a production bundle never
 * carries this branch; the ports are the ones in firebase.json. Every
 * feature module gets its Firestore and Storage handles from this same app,
 * so connecting the default instances here is enough.
 */
if (import.meta.env.VITE_USE_EMULATORS === '1') {
  const host = '127.0.0.1';
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(getFirestore(app), host, 8080);
  connectFunctionsEmulator(functions, host, 5001);
  connectStorageEmulator(getStorage(app), host, 9199);
}
